module.exports = __webpack_public_path__ + "media/images/icons/white-arrow-left-8a09fbc97bfc09c8541768418cf2937b.svg";